import keycloakClient from "@keycloak/keycloak";
import { Source } from "@services/sourceManagerApi/models/Source";
import { SOURCE_MANAGER_API_URL } from "../../config";
import {
  GetAllSourcesListRequest,
  UpdateSourceCategoriesRequest,
  UploadSourcesRequest
} from "./apiRequestsModels";

class SourceManagerApi {
  private baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  private getAuthHeaders(includeContentType: boolean = true): HeadersInit {
    const headers: HeadersInit = {
      Authorization: `Bearer ${keycloakClient.token}`,
      Accept: "application/json"
    };
    if (includeContentType) {
      headers["Content-Type"] = "application/json";
    }
    return headers;
  }

  private handleApiError(error: any): never {
    console.error("Error en la comunicación con el API de fuentes:", error);
    throw error;
  }

  async uploadSources(data: UploadSourcesRequest): Promise<boolean> {
    try {
      const formData = new FormData();
      formData.append("role_id", data.roleId.toString());
      data.files.forEach((file) => {
        formData.append("files", file);
      });

      const response = await fetch(`${this.baseUrl}/sources`, {
        method: "POST",
        headers: this.getAuthHeaders(false),
        body: formData
      });

      if (!response.ok) {
        throw new Error(
          `Error al subir las fuentes: ${response.status} ${response.statusText}`
        );
      }
      return true;
    } catch (error) {
      this.handleApiError(error);
    }
  }

  async getAllSources(): Promise<Source[]> {
    try {
      const response = await fetch(`${this.baseUrl}/sources`, {
        method: "GET",
        headers: this.getAuthHeaders(true)
      });

      if (!response.ok) {
        throw new Error(
          `Error al obtener las fuentes: ${response.status} ${response.statusText}`
        );
      }
      const responseData = (await response.json()) as GetAllSourcesListRequest;
      return responseData.sources;
    } catch (error) {
      this.handleApiError(error);
    }
  }

  async deleteSource(source_id: number): Promise<boolean> {
    try {
      const response = await fetch(`${this.baseUrl}/sources/${source_id}`, {
        method: "DELETE",
        headers: this.getAuthHeaders(true)
      });

      if (!response.ok) {
        throw new Error(
          `Error al eliminar las fuentes: ${response.status} ${response.statusText}`
        );
      }
      return true;
    } catch (error) {
      this.handleApiError(error);
    }
  }

  async updateSourceCategories(
    data: UpdateSourceCategoriesRequest
  ): Promise<boolean> {
    try {
      const formData = new FormData();

      data.categories_ids.forEach((role_id) => {
        formData.append("categories_ids", role_id.toString());
      });

      const response = await fetch(
        `${this.baseUrl}/sources/${data.source_id}/categories`,
        {
          method: "PATCH",
          headers: this.getAuthHeaders(false),
          body: formData
        }
      );
      if (!response.ok) {
        throw new Error(
          `Error al actualizar categorías del source: ${response.status} ${response.statusText}`
        );
      }
      return true;
    } catch (error) {
      this.handleApiError(error);
    }
  }
}

const _api = new SourceManagerApi(
  `${SOURCE_MANAGER_API_URL}/chatbot-source-manager-api/v1`
);

// exportamos solo lo que necesitamos
export const uploadSources = (req: UploadSourcesRequest) =>
  _api.uploadSources(req);

export const updateSourceCategories = (data: UpdateSourceCategoriesRequest) =>
  _api.updateSourceCategories(data);

export const getAllSources = () => _api.getAllSources();

export const deleteSource = (id: number) => _api.deleteSource(id);
